import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

/**
 * Belgeler ve bordro. Bildirim bağlantıları da burada karşılanır:
 * "/belgeler/istenenler" (belge talebi), "/belgeler/:id" (inceleme sonucu), "/bordro/:id" (yayımlanan pusula).
 * Ana ekrandaki "… yükleyin" işi "/belgeler"e, "… bordronuz hazır" işi "/bordro"ya gelir.
 */
const MyDocumentsPage = lazy(() => import("./MyDocumentsPage"));

export const routes: FeatureRoute[] = [
  { path: "belgeler", Component: MyDocumentsPage },
  { path: "belgeler/istenenler", Component: MyDocumentsPage },
  { path: "belgeler/:id", Component: lazy(() => import("./DocumentPage")) },
  { path: "bordro", Component: lazy(() => import("./MyPayslipsPage")) },
  { path: "bordro/:id", Component: lazy(() => import("./PayslipPage")) },
  { path: "ik/belgeler", Component: lazy(() => import("./HrDocumentsPage")) },
  { path: "ik/bordro", Component: lazy(() => import("./HrPayslipsPage")) },
  { path: "ik/bordro/:id", Component: lazy(() => import("./PayslipBatchPage")) },
];
